"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const api_1 = require("@react-google-maps/api");
const react_i18next_1 = require("react-i18next");
const getIcon_1 = __importDefault(require("../../utils/getIcon"));
const utils_1 = require("../../utils/utils");
// export default
function LargeScreenView({ searchResults, mapRef, selected, setSelected, currentLocation, resultBounds, resultBoundsPadding, markerRefs, focusOnLocation, hovered, setHovered, showMap, sizeWidth, }) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const [filteredSearchResults, setFilteredSearchResults] = (0, react_1.useState)([]);
    const [bounds, setBounds] = (0, react_1.useState)(new google.maps.LatLngBounds()
        .extend({
        lat: 41.6765556,
        lng: -95.1537399,
    })
        .extend({
        lat: 56.8593635,
        lng: -74.3201062,
    }));
    const debounceBoundsChange = (0, react_1.useRef)(null);
    const mapOnLoad = (0, react_1.useCallback)((ref) => {
        mapRef.current = ref;
        if (debounceBoundsChange.current !== null) {
            window.clearTimeout(debounceBoundsChange.current);
        }
        debounceBoundsChange.current = window.setTimeout(() => {
            var _a;
            if (resultBounds.current) {
                const boundsToSet = selected
                    ? resultBounds.current.extend({
                        lat: selected.lat,
                        lng: selected.lng,
                    })
                    : resultBounds.current;
                const boundsPaddingToSet = resultBoundsPadding.current;
                (_a = mapRef.current) === null || _a === void 0 ? void 0 : _a.fitBounds(boundsToSet, boundsPaddingToSet);
            }
        }, 100);
    }, [selected, mapRef, resultBounds, resultBoundsPadding]);
    const onBoundsChanged = (0, react_1.useCallback)(() => {
        if (debounceBoundsChange.current !== null) {
            window.clearTimeout(debounceBoundsChange.current);
        }
        debounceBoundsChange.current = window.setTimeout(() => {
            var _a;
            const newBounds = (_a = mapRef.current) === null || _a === void 0 ? void 0 : _a.getBounds();
            if (newBounds && !bounds.equals(newBounds)) {
                setBounds(newBounds);
            }
        }, 100);
    }, [bounds, mapRef]);
    (0, react_1.useEffect)(() => {
        if (searchResults) {
            setFilteredSearchResults([...searchResults]
                .filter((loc) => {
                return true;
            })
                .reverse());
        }
    }, [searchResults, mapRef]);
    const currentLocationMarker = (0, react_1.useMemo)(() => {
        return ((0, jsx_runtime_1.jsx)(api_1.Marker, { icon: {
                url: require("../../assets/my-location.png"),
                scaledSize: new google.maps.Size(13, 26),
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(6, 24),
            }, position: {
                lat: currentLocation === null || currentLocation === void 0 ? void 0 : currentLocation.lat,
                lng: currentLocation === null || currentLocation === void 0 ? void 0 : currentLocation.lng,
            }, title: `${t("myCurrentLocation")} (${currentLocation === null || currentLocation === void 0 ? void 0 : currentLocation.name})` }, filteredSearchResults.length + 1));
    }, [currentLocation, filteredSearchResults, t]);
    const mapVisible = (0, react_1.useMemo)(() => {
        return ((searchResults && searchResults.length > 0 && showMap) || sizeWidth > 767);
    }, [searchResults, showMap, sizeWidth]);
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "map", hidden: !mapVisible }, { children: (0, jsx_runtime_1.jsxs)(api_1.GoogleMap, Object.assign({ mapContainerStyle: { width: "100%", height: "100%" }, options: utils_1.mapOptions, onLoad: mapOnLoad, onBoundsChanged: onBoundsChanged }, { children: [filteredSearchResults.map((loc) => {
                    var _a;
                    return ((0, jsx_runtime_1.jsx)(api_1.Marker, { icon: (0, getIcon_1.default)({
                            selected: (selected === null || selected === void 0 ? void 0 : selected.id) === loc.id,
                            hovered: (hovered === null || hovered === void 0 ? void 0 : hovered.id) === loc.id,
                            highlight: loc.highlight,
                            number: loc.listIndex,
                        }), onLoad: (marker) => {
                            if (google.maps.CollisionBehavior &&
                                google.maps.CollisionBehavior.REQUIRED_AND_HIDES_OPTIONAL)
                                marker.set("collisionBehavior", google.maps.CollisionBehavior.REQUIRED_AND_HIDES_OPTIONAL);
                        }, ref: (ref) => {
                            var _a;
                            (_a = markerRefs.current) === null || _a === void 0 ? void 0 : _a.set(loc.id, ref === null || ref === void 0 ? void 0 : ref.marker);
                        }, onClick: () => {
                            setSelected(loc);
                            focusOnLocation(loc);
                        }, onMouseOver: () => {
                            if ((hovered === null || hovered === void 0 ? void 0 : hovered.id) !== loc.id)
                                setHovered(loc);
                        }, onMouseOut: () => {
                            if ((hovered === null || hovered === void 0 ? void 0 : hovered.id) === loc.id)
                                setHovered(null);
                        }, zIndex: (hovered === null || hovered === void 0 ? void 0 : hovered.id) === loc.id ? 4 : (selected === null || selected === void 0 ? void 0 : selected.id) === loc.id ? 3 : 2, title: (_a = loc.name) !== null && _a !== void 0 ? _a : undefined, position: { lat: loc.lat, lng: loc.lng } }, loc.id));
                }), currentLocationMarker] })) })));
}
exports.default = LargeScreenView;
